import * as _ from 'lodash';
import { useState } from 'react';

import { BUTTON_SIZE, LabeledTextInput } from '../../../components/generic';
import Button from '../../../components/generic/Button';
import FallbackImage from '../../../components/generic/FallbackImage';
import Flex from '../../../components/generic/Flex';
import List from '../../../components/generic/List';
import Loader from '../../../components/generic/Loader';
import Text from '../../../components/generic/Text';
import Box from '../../generics/Box';
import { useUser } from '../../hooks';

import ReleaseGroupList from './ReleaseGroupList';

import styles from './ReleaseGroupList.module.less';

const TokenInput = () => {
  const { tokenError } = useUser();
  const [tokenInput, setTokenInput] = useState<string>('');
  const { setToken, isLoading } = useUser();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles.tokenInput}>
      <Flex direction="column" justify="flex-start" align="flex-start" gap="16px">
        <Text.H4>Enter your authentication token to gain access</Text.H4>
        {/* Use a form to support enter key using keyboard */}
        <form
          onSubmit={(event) => {
            event.preventDefault();
            setToken(tokenInput);
            setTokenInput('');
          }}
        >
          <Flex direction="column" justify="flex-start" align="flex-start" gap="8px">
            <LabeledTextInput
              size="small"
              onChange={(value) => {
                setTokenInput(value);
              }}
              value={tokenInput}
              label="Token"
            />
            <Button isSubmitButton size={BUTTON_SIZE.SMALL} onClick={_.noop}>
              Verify
            </Button>
            {tokenError && <div className={styles.error}>{tokenError}</div>}
          </Flex>
        </form>
      </Flex>
      <FallbackImage src="no-data" alt="no data" />
    </div>
  );
};

const TokenInputContainer = () => {
  return (
    <>
      <Text.H3>
        <img src="/img/list-tree-duotone.svg" alt="list" /> Private SBOMs
      </Text.H3>
      <List>
        <List.Body>
          <Box>
            <TokenInput />
          </Box>
        </List.Body>
      </List>
    </>
  );
};

const PrivateReleaseGroupList = () => {
  const { isTokenAuthenticated } = useUser();

  return isTokenAuthenticated ? <ReleaseGroupList visibility="private" /> : <TokenInputContainer />;
};

export default PrivateReleaseGroupList;
